module.exports = __webpack_public_path__ + "img/avatar.4720bfa7.png";